import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  max-height: 200px;
  width: 100%;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ShowOptions = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  top: 45px;
  background: #fff;
  flex-direction: column;
  z-index: 10;
  border: none;
  border-top: none;
  border-radius: 0px 0px 8px 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  padding: 0 8px;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button<SearchProps>`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: ${({ haveResults }) =>
    !haveResults ? '8px 8px 0px 0px' : '8px'};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;

export const SearchContainer = styled.div<SearchProps>`
  position: relative;
  display: flex;
  height: 42px !important;
  width: 42px;
  align-items: center;
  justify-content: center;
  flex: 1;
  cursor: pointer;

  background: #fff;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 13px;
`;
export const Div = styled.button<SearchProps>`
  position: relative;
  flex-direction: column;
  display: flex;
  border: none;
  align-items: center;
  height: 42px;
  max-height: 42px;
  width: 42px;
  max-width: 42px;
  margin-left: 8px;
  background-color: transparent;

  :disabled {
    cursor: not-allowed;
  }
`;

export const Search = styled.div<SearchProps>`
  color: ${beam.font.primary};
  box-sizing: border-box;
  /* borders/light-border */
  flex: 1;
  -webkit-appearance: none;
  ::placeholder {
    color: #787878;
  }
  :disabled {
    cursor: default;
  }
  font-family: 'Poppins', sans-serif;

  color: ${beam.font.primary};
  background: #fff;
  min-width: 80px;
  width: 100%;
  max-width: 100%;
  box-shadow: ${({ haveResults }) =>
    !haveResults ? 'none' : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border: none;
  border-radius: 8px;
  background: ${beam.color.pureWhite};
  height: 36px;
  max-height: 32px;
  cursor: ${({ haveResults }) => (!haveResults ? 'pointer' : 'pointer')};
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;

  :hover {
    background: ${({ haveResults }) =>
      !haveResults ? beam.background.card : 'transparent'};
  }
`;
interface SearchImgProps {
  isDisabled?: boolean;
}
export const SearchImg = styled.img<SearchImgProps>`
  left: 12px;
  position: absolute;
  z-index: 1;
  margin-right: -10px;
  margin-top: -5px;
  visibility: ${({ isDisabled }) => (isDisabled ? 'hidden' : 'visible')};
`;

export const Line = styled.div`
  border-top: 1px solid #e9edf1;
  width: auto;
  display: flex;
  position: absolute;
  bottom: 0;
  margin-left: 16px;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  white-space: nowrap;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const StyledOption = styled.text`
  display: flex;
  user-select: none;
  width: 100%;
  align-items: center;
  color: ${beam.color.pureBlack};
  align-items: flex-start;
  margin: 8px 0;
  white-space: nowrap;
  padding: 8px;
  justify-content: flex-start;
  text-align: start;
  cursor: pointer;
  border-radius: 8px;

  font-size: 14px;

  :hover {
    background: ${beam.background.hover};
  }
`;

export const BlueButton = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  font-style: normal;

  white-space: nowrap;
  background: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background: transparent;
  border-radius: 8px;
`;
export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;
